import React from 'react';
import { Link } from 'react-router-dom';

const SidebarPost = ({ data = [] }) => {
  // Show latest 5 posts from passed data
  const posts = data.slice(0, 5);

  return (
    <ul>
      {posts.map((post) => (
        <li key={post.id}>
          <Link className="d-block" to={`${process.env.PUBLIC_URL}/content-details/${post.id}`}>
            {post.title}
          </Link>
          <span className="cate">
            {post.categories && post.categories.length > 0 ? post.categories[0] : ''}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default SidebarPost;
